<template>
    <b-button ref="button"
              v-on="$listeners"
              :block="block"
              :disabled="disabled"
              :size="size"
              :variant="variant"
              :type="type"
              :tag="tag"
              :pressed="pressed"
              :href="href"
              :rel="rel"
              :target="target"
              :active="active"
              :to="to"
              :append="append"
              :replace="replace"
              :event="event"
              :activeClass="activeClass"
              :exact="exact"
              :exactActiveClass="exactActiveClass"
              :routerTag="routerTag"
              :noPrefetch="noPrefetch">
        <i class="far" :class="{['fa-' + icon]: true}"></i>
        <span v-show="!minimizeOn || !icon || minimizeOn < $display.clientWidth">
            <slot>{{text}}</slot>
        </span>
        <b-tooltip v-if="text && !(minimizeOn < $display.clientWidth)" :target="() => $refs['button']" :title="text"/>
    </b-button>
</template>

<script>
    import {ButtonPlugin} from 'bootstrap-vue'
    import mixin from './mixin'

    export default {
        name: "Button",
        extends: ButtonPlugin,
        mixins: [mixin],
        props: {
            icon: {
                type: String,
                default: null
            },
            minimizeOn: {
                type: Number,
                default: null
            },
            text: {
                type: String,
                default: null,
            }
        },
    }
</script>